export enum PackingTypeEnum {
  Unit = 'unit',
  Rack = 'display',
  Pack = 'carton',
  Pallet = 'pallet',
}
